// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteIcon_root__Ty5Fc"};